import React, { useState, useEffect } from 'react'
import { PostData, fetchData } from '../Services/httpHandelars'
import { useGlobalContext } from '../context'
import Loader from '../Components/Loader';
import Snackbar from '../Components/Snackbar';
import { useNavigate } from 'react-router-dom';


export const AssaySetup = () => {


    const [form, setForm] = useState({ _id: "", assayName: "" })
    const [assaySetup, setAssaySetup] = useState([])
    const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })

    const { setLoading, loading, setUser } = useGlobalContext();
    const navigate = useNavigate();

    useEffect(
        () => {
            if (snacBar.snacStatus === true) {
                setTimeout(() => setSnacBar(false), 3000);
            }
        },

        [snacBar.snacStatus]
    );

    useEffect(() => {
        fetchData("/api/getAssaySetup").then((success) => {
            success = JSON.parse(success)
            if(!success.status && success.message.includes("jwt")){
                setUser(null)
                navigate('/Login')
            }
            else if(success.status) {
                const assaySetup = success.data;
                setAssaySetup(assaySetup);
            }
        })
    }, [])



    const HandleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleEditButton = (id) => {
        const editAssaySetup = assaySetup.find(cSetup => cSetup._id === id)
        setForm({
            ...form, _id: editAssaySetup._id, assayName: editAssaySetup.AssayName, 
     
        });
    }

    console.log(assaySetup, " -----44")

    const handleSubmit = () => {
        setLoading(true)

        if (form._id) {
            const update = {
                assayName: form.assayName.trim(),
                _id: form._id
            }

            

            PostData("/api/updateAssaySetup", update).then((success) => {
                setLoading(false)
                if (success.status === true) {
                    setForm({})
                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: success.message,
                        snackType: "Success"
                    })
                } else {
                    setLoading(false)

                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                }
                fetchData("/api/getAssaySetup").then((success) => {
                    success = JSON.parse(success)
                    const updateAssaySetup = success.data
                    setAssaySetup(updateAssaySetup)
                })
            }).catch((err) => {
                setLoading(false)

                console.log("asd--->", err)
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Responce Failed",
                    snackType: "Error"
                })
            })
        }
        else {
            if (form.assayName ){
                const data = {
                    assayName: form.assayName   
                   
                            }
                setForm({})
    
                PostData("/api/saveAssaySetup", data).then((success) => {
                    setLoading(false)
                    console.log(success, "----104")
                    if (success.status === true) {
                        setSnacBar({
                            ...snacBar,
                            snacStatus: success.status,
                            message: success.message,
                            snackType: "Success"
                        })
                        let AssaySetupData = assaySetup;
                        AssaySetupData.push(success.success)
                        setAssaySetup(AssaySetupData)
                    } else {
                        setLoading(false)
    
                        setSnacBar({
                            ...snacBar,
                            snacStatus: success.status,
                            message: "Responce Failed",
                            snackType: "Error"
                        })
                    }
                    // fetchData("/api/getAssaySetup").then((success) => {
                    //     const assaySetup = JSON.parse(success)
                    //     setAssaySetup(assaySetup)
                    // })
                }).catch((err) => {
                    setLoading(false)
    
                    console.log("asd--->", err)
                    setSnacBar({
                        ...snacBar,
                        snacStatus: true,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                })
            } else {
                setLoading(false)
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Kindly fill all the fields",
                    snackType: "Error"
                })
            }
        }

    }

    return (
        <>
        {!loading ? <>
            <div>
                <div className='grid justify-center font-medium py-4 text-gray-700'>
                    Assay Setup
                </div>
                <div className='shadow overflow-hidden sm:rounded-md mt-5 '>
                    <div className='bg-white flex flex-col items-center justify-center px-4 py-10 sm:p-6 w-full'>
                        <div className=" w-96 py-6 px-12 ">
                            <div className="col-span-1">
                                <label htmlFor="AssayName" className="block text-sm font-medium text-gray-700">
                                    Assay Name
                                </label>
                                <input
                                    type="text"
                                    name="assayName"
                                    value={form.assayName}
                                    onChange={HandleChange}
                                    id="assayName"
                                    autoComplete="given-name"
                                    className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                />
                            </div>


                        

                            

                        </div>
                        <div className='grid justify-center'>
                            <button
                                onClick={handleSubmit}
                                type='submit'
                                className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                            >
                                {form._id ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>

                <div className='flex justify-center'>
                    <table className="w-9/12 text-sm text-center text-gray-500 dark:text-gray-400 mt-20">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="py-3 px-6">
                                 Assay Name
                                </th>
                                
                                <th scope="col" className="py-3 px-6">
                                   Created at
                                </th>
                             
                                <th scope="col" className="py-3 px-6">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                assaySetup?.map(cSetup => (
                                    <tr key={cSetup._id} className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                                        <>
                                            <td className='px-6'>{cSetup.AssayName}</td>
                                            <td className='px-6'>{cSetup.CreationDetails.ActionTakenOn}</td>
                                            <td className='px-6'><button onClick={() => handleEditButton(cSetup._id)} className='group relative py-1 px-3 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'>Edit</button></td>
                                        </>
                                    </tr>
                                )
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {snacBar?.snacStatus &&
                <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
            }
        </>
            : <Loader />
}
        </>
    )
}
